import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from '../services/auth/auth.service';
//import { SnackBarService } from '../services/snack-bar/snack-bar.service';
import { environment } from '../../../../src/environments/environment.prod';
import HttpRemoteActionResponse from './http-remote-action-response';
import { Observable } from "rxjs";

export class HttpUtil {
    private http: HttpClient;
    private authService: AuthService;
    // private snackbarService: SnackBarService;
    private methodType: string;

    constructor(http: any, authService: any, methodType: string) {
        this.http = http;
        this.authService = authService;
        this.methodType = methodType;
    }


    public async callHttp(url: string, endpoint: string, options: any, log: string, errorType: string, headers = {}) {
        const body: any = options['data'];
        let authHeader: any;
        const isMultipart = options.hasOwnProperty('multipart') && options['multipart'];



        const secureHeaderBody = () => {
            authHeader = this.authService.getAuthorizationHeader();
        };

        const inSecureHeaderBody = () => {
            authHeader = {};
            if (options.hasOwnProperty('exceptional') && options['exceptional']) {
                authHeader = options['authHeader'];
            }
        };

        (options['no-header']) ? inSecureHeaderBody() : secureHeaderBody();
        if (!isMultipart) {
            // For CSV in Report Manager
            if (this.methodType === 'get_csv') {
                authHeader = this.authService.getAuthorizationHeader();
                authHeader['Content-Type'] = 'text/plain; charset=utf-8';
                authHeader['Accept'] = "text/csv; charset=utf-8"
                // changed
                authHeader['platform'] = 'postman';
                authHeader['version'] = '1.0';
                authHeader['language'] = 'en';
            } else {
                authHeader['Accept'] = "application/json",
                    authHeader['Content-Type'] = 'application/json';
                authHeader['device-type'] = 'ios';
                authHeader['device-type'] = 'ios';
                authHeader['app-version'] = 'ssss';
                authHeader['device-id'] = '12345';
                // changeddevice-id:32435

                authHeader['platform'] = 'postman';
                authHeader['version'] = '1.0';
                authHeader['language'] = 'en';
            }

        } else {
            authHeader['platform'] = 'postman';
            authHeader['version'] = '1.0';
            authHeader['language'] = 'en';
            authHeader['device-type'] = 'ios';
            authHeader['app-version'] = 'ssss';
            authHeader['device-type'] = 'ios';
            authHeader['device-id'] = '1234';
        }



        const httpOptions: any = {
            headers: new HttpHeaders(authHeader),
        };

        let customisedBody: string;
        if (!isMultipart) {
            customisedBody = JSON.stringify(body);
        } else {
            customisedBody = body;
            // authHeader['Content-Type'] = 'multipart/form-data';
        }
        // if (window) {
        //     return await new Promise((res, rej) => {
        //         try {
        //             this.actionInvoker({
        //                 action: endpoint,
        //                 payload: customisedBody
        //             }, function (r:any, e:any) {
        //                 const response = new HttpRemoteActionResponse(r, e, false);
        //                 if (response.isError) {
        //                     console.error(`Error response isError=true`, response);
        //                     rej(response);
        //                 } else {
        //                     res(response);
        //                 }
        //             });
        //         } catch (err) {
        //             console.error(err);
        //             rej(new HttpRemoteActionResponse(null, {
        //                 message: `Error on ${endpoint}`
        //             }));
        //         }
        //     }).then(async (res:any) => {
        //         return await res['httpResponse'];
        //     }).catch(async rej => {
        //         return await rej;
        //     });
        // } else {
        if (this.methodType === 'post') {

            return await this.http.post(url, customisedBody, httpOptions)
                .toPromise().then((response: any) => {
                    switch (response['status_code']) {
                        case 403:

                            break;
                        case 200:
                            return response;
                        default:
                            return response;
                    }
                }).catch(error => {

                    switch (error.status) {
                        case 204:
                            //    this.snackbarService.show('Server is not giving any response.', '');
                            break;
                        case 403:

                            // console.info('403: err.error =', err.error, ';');
                            break;
                        case 404:
                            // console.info('404: err.error =', err.error, ';');
                            break;
                        case 304:

                            // console.info('304: err.error =', err.error, ';');
                            break;
                        case 305:
                            // console.info('305: err.error =', err.error, ';');
                            break;
                        default:
                        // console.info('err.error =', err.error, ';');
                    }
                });
        } else if (this.methodType === 'get') {
            return await this.http.get(url, httpOptions)
                .toPromise().then((response: any) => {

                    switch (response['status_code']) {
                        case 401:
                            localStorage.clear()
                            break;
                        case 403:

                            break;
                        case 200:
                            return response;
                        default:
                            return response;
                    }
                }).catch(error => {

                    switch (error.status) {
                        case 204:
                            //    this.snackbarService.show('Server is not giving any response.', '');
                            break;
                        case 403:
                            // console.info('403: err.error =', err.error, ';');
                            break;
                        case 404:
                            // console.info('404: err.error =', err.error, ';');
                            break;
                        case 304:

                            // console.info('304: err.error =', err.error, ';');
                            break;
                        case 305:
                            // console.info('305: err.error =', err.error, ';');
                            break;
                        default:
                            localStorage.clear();
                        // console.info('err.error =', err.error, ';');
                    }
                });
        } else if (this.methodType === 'put') {
            return await this.http.put(url, customisedBody, httpOptions)
                .toPromise().then((response: any) => {
                    switch (response['statusCode']) {
                        case 403:

                            break;
                        case 200:
                            return response;
                        default:
                            return response;
                    }
                }).catch(error => {
                    switch (error.status) {
                        case 204:
                            //   this.snackbarService.show('Server is not giving any response.', '');
                            break;
                        case 403:

                            // console.info('403: err.error =', err.error, ';');
                            break;
                        case 404:
                            // console.info('404: err.error =', err.error, ';');
                            break;
                        case 304:

                            // console.info('304: err.error =', err.error, ';');
                            break;
                        case 305:
                            // console.info('305: err.error =', err.error, ';');
                            break;
                        default:
                        // console.info('err.error =', err.error, ';');
                    }
                });
        } else if (this.methodType === 'get_csv') {
            httpOptions['responseType'] = 'text';
            return this.http.get(url, httpOptions).toPromise().then((response: any) => {
                return response;
            });
        } else if (this.methodType === 'delete') {
            return await this.http.delete(url, httpOptions)
                .toPromise().then((response: any) => {
                    switch (response['status_code']) {
                        case 403:

                            break;
                        case 200:
                            return response;
                        default:
                            return response;
                    }
                }).catch(error => {
                    switch (error.status) {
                        case 204:
                            //    this.snackbarService.show('Server is not giving any response.', '');
                            break;
                        case 403:
                            // console.info('403: err.error =', err.error, ';');
                            break;
                        case 404:
                            // console.info('404: err.error =', err.error, ';');
                            break;
                        case 304:

                            // console.info('304: err.error =', err.error, ';');
                            break;
                        case 305:
                            // console.info('305: err.error =', err.error, ';');
                            break;
                        default:
                        // console.info('err.error =', err.error, ';');
                    }
                });
        }
        //}
    }

    downloadFile(data: any) {
        const replacer = (key: any, value: any) => (value === null ? '' : value); // specify how you want to handle null values here
        const header = Object.keys(data);
        const csv = data.map((row: any) =>
            header
                .map((fieldName) => JSON.stringify(row[fieldName], replacer))
                .join(',')
        );
        csv.unshift(header.join(','));
        const csvArray = csv.join('\r\n');

        const a = document.createElement('a');
        const blob = new Blob([csvArray], { type: 'text/csv' });
        const url: any = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'myFile.csv';
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }
    private actionInvoker(obj: any, callback: any) {
        const logResponseAndCallback = (res: any, env: any) => {
            callback(res, env);
        };
        // const invoker = window['dbg_backend']['remoting']['Manager']['invokeAction'];
        // const manager = window['dbg_backend']['remoting']['Manager'];
        // if (obj.payload && obj.payload.constructor === Array) {
        //     const allArgs = [obj.action].concat(obj.payload).concat([logResponseAndCallback, { escape: false, timeout: 120000 }]);
        //     if (!environment.production) {
        //         // tslint:disable-next-line:no-console
        //       
        //     }
        //     invoker.apply(manager, allArgs);
        // }
        // // Request has a payload, but it is a scalar
        // else if (obj.payload) {
        //     invoker.apply(manager, [obj.action, obj.payload, logResponseAndCallback, { escape: false, timeout: 120000 }]);
        // }
        // // Request has no payload
        // else {
        //     invoker.apply(manager, [obj.action, logResponseAndCallback, { escape: false, timeout: 120000 }]);
        // }
        // tslint:enable:one-line
    }
}
